import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const ShareSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default ShareSVG;
